import { render, staticRenderFns } from "./pic.vue?vue&type=template&id=3199282c&scoped=true&"
import script from "./pic.vue?vue&type=script&lang=ts&"
export * from "./pic.vue?vue&type=script&lang=ts&"
import style0 from "./pic.vue?vue&type=style&index=0&id=3199282c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3199282c",
  null
  
)

export default component.exports